import React from 'react';
import { TouchableOpacity, View } from 'react-native';

import { Text } from '@/components/ui/text';
import { formatDate, profileInitials } from '../profileFormat';
import { profileWebStyles } from '../profileStyles';
import type { Translate, UserProfile } from '../profileTypes';

interface AccountDetailsCardProps {
  profile: UserProfile;
  isTiny: boolean;
  onEditProfile: () => void;
  t: Translate;
}

/** Avatar, name, email, account type and member-since date. */
export function AccountDetailsCard({ profile, isTiny, onEditProfile, t }: AccountDetailsCardProps) {
  const initials = profileInitials(profile.full_name, profile.email);

  return (
    <View style={[profileWebStyles.identityCard, isTiny && profileWebStyles.identityCardTiny]}>
      <View style={profileWebStyles.avatar}>
        <Text style={profileWebStyles.avatarText}>{initials}</Text>
      </View>
      <View style={profileWebStyles.identityInfo}>
        <Text style={profileWebStyles.identityName}>{profile.full_name || t('profile.notSet')}</Text>
        <Text style={profileWebStyles.identityEmail}>{profile.email}</Text>
        <View style={profileWebStyles.identityMetaRow}>
          <Text style={profileWebStyles.identityMeta}>{profile.user_type.replace('_', ' ').toUpperCase()}</Text>
          <View style={profileWebStyles.metaDot} />
          <Text style={profileWebStyles.identityMeta}>
            {t('profile.memberSince')}: {formatDate(profile.created_at)}
          </Text>
        </View>
      </View>
      <TouchableOpacity
        style={profileWebStyles.outlineButton}
        onPress={onEditProfile}
        accessibilityRole="button"
      >
        <Text style={profileWebStyles.outlineButtonText}>{t('profile.webEditProfile')}</Text>
      </TouchableOpacity>
    </View>
  );
}
